import { makeStyles } from '@material-ui/core'
import { TreatmentTypes } from 'consts/treatmentConsts'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import usePreviouslyUploadedStls from './usePreviouslyUploadedStls'
import useTxTracker from 'components/Patients/TreatmentTracker/useTxTracker'

const useStyles = makeStyles({
  uploadedSTLs: {
    background: '#F2F3F5',
    height: '100%',
    marginTop: 10,
    borderRadius: 10,
    padding: 20
  },
  stlsRange: {
    lineHeight: '30px'
  },
  flattenedUploadedSTLs: {
    background: '#F2F3F5',
    borderRadius: 10,
    padding: '0px 20px',
    display: 'flex',
    justifyContent: 'space-between'
  },
  divider: {
    padding: '0px 10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
})

const PreviouslyUploadedStls = ({ stls, treatmentType, provider, variant = 'normal' }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const { calculateTreatmentType } = useTxTracker()

  const calculatedTreatmentType = calculateTreatmentType({ treatmentType, provider })

  const { generateAlignersUploadedStls, generateBracesUploadedStls } = usePreviouslyUploadedStls()

  const upperStls = useMemo(() => {
    if (calculatedTreatmentType === TreatmentTypes.Aligners) {
      return generateAlignersUploadedStls(stls?.upper)
    }

    return generateBracesUploadedStls(stls?.upper)
  }, [generateAlignersUploadedStls, generateBracesUploadedStls, stls, calculatedTreatmentType])

  const lowerStls = useMemo(() => {
    if (calculatedTreatmentType === TreatmentTypes.Aligners) {
      return generateAlignersUploadedStls(stls?.lower)
    }

    return generateBracesUploadedStls(stls?.lower)
  }, [generateAlignersUploadedStls, generateBracesUploadedStls, stls, calculatedTreatmentType])

  return variant === 'normal' ? (
    <div className={classes.uploadedSTLs}>
      {stls ? (
        <>
          <div className={classes.stlsRange}>
            {t('dialogs.patientInfo.txTrackerSetup.upperLabel')}: {upperStls}
          </div>
          <div className={classes.stlsRange}>
            {t('dialogs.patientInfo.txTrackerSetup.lowerLabel')}: {lowerStls}
          </div>
        </>
      ) : (
        <div>{t('dialogs.patientInfo.txTrackerSetup.noStls')}</div>
      )}
    </div>
  ) : (
    <div className={classes.flattenedUploadedSTLs}>
      <span className={classes.stlsRange}>
        {t('dialogs.patientInfo.txTrackerSetup.upperLabel')}: {upperStls}
      </span>
      <div className={classes.divider}>|</div>
      <span className={classes.stlsRange}>
        {t('dialogs.patientInfo.txTrackerSetup.lowerLabel')}: {lowerStls}
      </span>
    </div>
  )
}
export default PreviouslyUploadedStls
